import { apiClient } from '@/lib/api-client';
import { TriApiDatasource } from '../data/datasources/tri-api.datasource';
import { TriRepositoryImpl } from '../data/repositories/tri.repository.impl';

const apiDatasource = new TriApiDatasource(apiClient);
const repository = new TriRepositoryImpl(apiDatasource);

export const triContainer = { repository };
